import { alpha, Box, ButtonBase, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Container from '../../../layout/Container';
import Gallery from '../components/Gallery';
import VideoGallery from '../components/VideoGallery';

const GalleryPage: React.FC = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const tabFromUrl = searchParams.get('tab');
    const [tab, setTab] = useState(tabFromUrl === 'video' ? 1 : 0);

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (tabFromUrl === 'video') setTab(1);
    }, [tabFromUrl]);

    return (
        <Box>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("seo.gallery.title")}</title>
                <meta name="description" content={t("seo.gallery.description")} />
                <link rel="canonical" href="https://enduro-connection-radusa.com/gallery/" />
                <meta property="og:title" content={t("seo.gallery.title")} />
                <meta property="og:description" content={t("seo.gallery.ogDescription")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://enduro-connection-radusa.com/gallery/" />
            </Helmet>
            <Container>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <Box
                        sx={(theme) => ({
                            display: 'inline-flex',
                            gap: 0.5,
                            p: 0.5,
                            borderRadius: 3,
                            backgroundColor: alpha(theme.palette.background.paper, 0.6),
                            border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                            boxShadow: `0 2px 12px ${alpha(theme.palette.common.black, 0.06)}`,
                        })}
                    >
                        <ButtonBase
                            focusRipple
                            onClick={() => setTab(0)}
                            sx={(theme) => ({
                                px: 3,
                                py: 1.25,
                                borderRadius: 2.5,
                                transition: 'all 0.2s ease',
                                color: tab === 0 ? '#fff' : theme.palette.text.primary,
                                backgroundColor: tab === 0 ? theme.palette.primary.main : 'transparent',
                                fontWeight: tab === 0 ? 700 : 600,
                                '&:hover': {
                                    backgroundColor: tab === 0 ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.1),
                                },
                            })}
                        >
                            <Typography variant="body1" fontWeight="inherit" sx={{ textTransform: 'none' }}>
                                {t('gallery.images')}
                            </Typography>
                        </ButtonBase>
                        <ButtonBase
                            focusRipple
                            onClick={() => setTab(1)}
                            sx={(theme) => ({
                                px: 3,
                                py: 1.25,
                                borderRadius: 2.5,
                                transition: 'all 0.2s ease',
                                color: tab === 1 ? '#fff' : theme.palette.text.primary,
                                backgroundColor: tab === 1 ? theme.palette.primary.main : 'transparent',
                                fontWeight: tab === 1 ? 700 : 600,
                                '&:hover': {
                                    backgroundColor: tab === 1 ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.1),
                                },
                            })}
                        >
                            <Typography variant="body1" fontWeight="inherit" sx={{ textTransform: 'none' }}>
                                {t('gallery.videos')}
                            </Typography>
                        </ButtonBase>
                    </Box>
                </Box>
                {tab === 0 && <Gallery />}
                {tab === 1 && <VideoGallery />}
            </Container>
        </Box>
    );
};

export default GalleryPage;
